export const LOADING = {
  PAGE: 'page',
  AREA: 'area',
} as const;

export type TLoadingType = (typeof LOADING)[keyof typeof LOADING];

export type TLoadingRequest = {
  type?: TLoadingType;
  title?: string;
  action?: string;
  message?: string;
  timeout?: number;
};
